import { store } from "../store/store";
import { httpService } from "./http.service";

const BASE_URL = "stripe-payment";

export const stripePaymentService = {
  paymentIntent,
  getBillingBId,
  createCust,
  createCheckSession,
  payment,
  getCardInfo,
  updatePayMethod,
  dataSession,
  existCustomer,
  ensureBilling
};

function getAuthHeader() {
  const token = store.getState().auth?.token;
          
  return {
    headers: { Authorization: `Bearer ${token}` }
  };
}

async function paymentIntent(cardNumber, cardExpiryElement, cardCvc, cardClientName, amount) {
  return "OK";
}


async function getBillingBId(accountId) {
  const data = await httpService.get(`${BASE_URL}/get-billing/${accountId}`, getAuthHeader());
  return data;
}

async function ensureBilling(accountId, customerId) {
  const body = customerId ? { customerId } : {};
  const data = await httpService.post(`${BASE_URL}/ensureBilling/${accountId}`, body, getAuthHeader());
  return data;
}

async function createCust(body) {
  try {
    const data = await httpService.post(`${BASE_URL}/create-customer`, body, getAuthHeader());
    return data;
  } catch (error) {
    console.error('Erro ao criar cliente:', error);
    throw error;
  }
}

async function existCustomer(customerId) {
  try {
    const result = await httpService.get(`${BASE_URL}/check-customer/${customerId}`, getAuthHeader());
    return result;
  } catch (error) {
    console.error('Erro ao criar cliente:', error);
    throw error;
  }
}

async function createCheckSession(body, plan) {
  try {
    const payload = { ...body, plan };
    const data = await httpService.post(`${BASE_URL}/create-checkout-session`, payload, getAuthHeader());
    return data;
  } catch (error) {
    console.error('Erro ao criar sessão:', error);
    throw error;
  }
}

async function payment(body, plan) {
  try {
    const payload = { ...body, plan };
    const data = await httpService.post(`${BASE_URL}/payment-intent`, payload, getAuthHeader());
    return data;
  } catch (error) {
    console.error('Erro ao realizar pagamento:', error);
    throw error;
  }
}

async function getCardInfo(customerId) {
  try {
    const data = await httpService.post(`${BASE_URL}/get-card-info`, { customerId }, getAuthHeader());
    return data;
  } catch (error) {
    console.error('Erro ao buscar informações do cartão:', error);
    throw error;
  }
}


async function updatePayMethod(body, plan) {
  try {
    const payload = { ...body, plan };
    const data = await httpService.post(`${BASE_URL}/update-card-session`, payload, getAuthHeader());
    return data;
  } catch (error) {
    console.error('Erro ao criar sessão:', error);
    throw error;
  }
}

async function dataSession(id) {
  const data = await httpService.get(`${BASE_URL}/checkout-session/${id}`, getAuthHeader());
  return data;
}